import { useTranslation } from "react-i18next";
import { Body1, Button, Modal, Stack } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/consent-details/ConsentDetailsRevokeModal.tsx
const ConsentDetailsRevokeModal = ({ consent, opened, onClose, handleConsentAction }) => {
	const { t } = useTranslation("cons");
	const consentDetailsRevokeModalBody = consent.required ? t("consent.actions.revoke.modal.required.body") : t("consent.actions.revoke.modal.optional.body");
	return /* @__PURE__ */ jsx(Modal, {
		title: t("consent.actions.revoke.modal.title"),
		opened,
		onClose,
		children: /* @__PURE__ */ jsxs(Stack, {
			gap: "sm",
			children: [
				/* @__PURE__ */ jsx(Body1, { children: consentDetailsRevokeModalBody }),
				/* @__PURE__ */ jsx(Button, {
					color: "error",
					onClick: () => handleConsentAction("REVOKED"),
					children: t("consent.actions.revoke.button")
				}),
				/* @__PURE__ */ jsx(Button, {
					variant: "outline",
					color: "gray",
					onClick: onClose,
					children: t("consent.actions.revoke.modal.cancel")
				})
			]
		})
	});
};

//#endregion
export { ConsentDetailsRevokeModal };